<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container pt-4 pb-5">
    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      style="top: 10px"
    >
      {{ alert.message }}
    </ngb-alert>

    <ngb-alert
      *ngIf="pet.status === petStatus.Deceased"
      [dismissible]="false"
      [type]="'info'"
      class="mb-5"
    >
      <h4 class="alert-heading">{{ pet.name }} has passed away.</h4>
      <div class="row">
        <div class="col-12">
          <p>
            If your pet has been marked as passed away in error, please get in touch with us on
            <strong>{{ companyPhoneNumber }}</strong>
            .
          </p>
        </div>
      </div>
    </ngb-alert>

    <ngb-alert
      *ngIf="
        (pet.residence === petResidenceStatus.Lost || pet.residence === petResidenceStatus.Stolen) &&
        pet.status !== petStatus.Deceased
      "
      [dismissible]="false"
      [type]="'info'"
      class="mb-5"
    >
      <h4 class="alert-heading">
        {{ pet.name }} is {{ pet.residence === petResidenceStatus.Lost ? 'missing' : 'stolen' }}.
      </h4>
      <div class="row">
        <div *ngIf="!userService.isUserBasicOrBasicPlus(user.productType)" class="col-12">
          <p
            *ngIf="
              activeMissingReport &&
              (activeMissingReport.reportStatus === petMissingReportStatus.AwaitingModeration ||
                activeMissingReport.reportStatus === petMissingReportStatus.Open)
            "
          >
            Your pet has been reported as
            {{ pet.residence === petResidenceStatus.Lost ? 'missing' : 'stolen' }}.
            <a
              class="alert-link"
              [routerLink]="['/lost-and-found', 'missing-pet', activeMissingReport.id]"
            >
              View, share or update your lost pet listing
            </a>
            .
          </p>
          <p
            *ngIf="
              activeMissingReport &&
              activeMissingReport.reportStatus === petMissingReportStatus.AwaitingClosureFound
            "
          >
            Someone has reported your pet as found. Please confirm it by
            <a
              class="alert-link"
              [routerLink]="['/lost-and-found', 'missing-pet', activeMissingReport.id]"
            >
              updating your lost pet listing
            </a>
            .
          </p>
          <p
            *ngIf="
              activeMissingReport &&
              activeMissingReport.reportStatus === petMissingReportStatus.AwaitingClosureDeceased
            "
          >
            We have an update on your missing pet. Please call us on
            {{ companyPhoneNumber }} as soon as you can.
          </p>
          <p *ngIf="!activeMissingReport">
            Someone has reported your pet as missing. Please
            <a class="alert-link" [routerLink]="['/my-pet', pet.id, 'report-missing']">
              create your missing pet report here
            </a>
            so we can help find {{ pet.name }}.
          </p>
        </div>
        <div *ngIf="userService.isUserBasicOrBasicPlus(user.productType)" class="col-12">
          <p>
            If you have not reported your pet as
            {{ pet.residence === petResidenceStatus.Lost ? 'missing' : 'stolen' }}, please call us on
            {{ companyPhoneNumber }}. If your pet is no longer missing or this is a mistake, please
            <span class="alert-link btn-link" (click)="onClickMarkFound()">
              click here to mark your pet as found
            </span>
            .
          </p>
        </div>
      </div>
    </ngb-alert>
    <ngb-alert *ngIf="rejectedMissingReport" [dismissible]="false" type="danger" class="mb-5">
      <h4 class="alert-heading">
        {{ pet.name }} is {{ pet.residence === petResidenceStatus.Lost ? 'missing' : 'stolen' }}.
      </h4>
      <div class="row">
        <div class="col-12">
          <p>
            There's something not quite right with your missing pet report.
            <a
              class="alert-link"
              [routerLink]="['/lost-and-found', 'missing-pet', rejectedMissingReport.id, 'edit']"
            >
              Please review and try again
            </a>
            .
          </p>
        </div>
      </div>
    </ngb-alert>

    <div class="row">
      <div class="col-12">
        <div *appFeatureFlag="'isPetImageEditAvailable'" class="pet-image-wrapper">
          <div *ngIf="pet.isTokPaymentRequired" class="mat-chip-avatar-orange"></div>
          <div *ngIf="pet.isTokPaymentRequired" class="mat-chip-avatar-icon">
            <img
              src="/assets/images/home/triangle-exclamation.svg"
              class="petplan-image banner-left"
              alt="petplan-banner"
            />
          </div>
          <div
            class="pet-image"
            [ngStyle]="petImage && { 'background-image': 'url(' + petImage + ')' }"
          ></div>
          <div *ngIf="pet.status !== petStatus.Deceased" class="pet-image-add-edit">
            <button
              class="btn btn-secondary text-white btn-sm"
              (click)="openImageUploader()"
              [disabled]="pet.isTokPaymentRequired"
            >
              {{ pet.imageUrl ? 'Edit' : 'Add' }} image
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="pet.isTokPaymentRequired" class="row mt-3">
      <div class="col-12 text-center">
        <div class="tok-incomplete-text"><b>Transfer of keepership incomplete</b></div>
      </div>
    </div>
    <div>
      <div *ngIf="pet.isTokPaymentRequired" class="row justify-content-center">
        <div class="justify-content-center align-items-center flex-column">
          <div class="mt-3 alert alert-dark">
            <p class="text-center">
              The transfer of keepership for this pet has not been completed yet.
              <br />
              To transfer this pet into your account please follow these steps.
            </p>
            <div class="d-flex justify-content-center">
              <ol>
                <li class="box-list">Verify and complete the pet’s details</li>
                <li class="box-list">Add your address</li>
                <li class="box-list">Complete the payment</li>
              </ol>
            </div>
            <p class="text-center">
              Once these steps are completed, the pet will be added to your account.
            </p>
          </div>
        </div>
      </div>
      <div *ngIf="pet.isTokPaymentRequired" class="row mt-1 justify-content-center">
        <div class="col-12 text-center tok-complete-button">
          <button
            type="submit"
            class="btn btn-primary w-100"
            (click)="redirectToCompletTOK()"
            [disabled]="loading"
          >
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-3"
            ></fa-icon>
            Complete transfer of keepership
          </button>
        </div>
      </div>
      <div class="row mt-5">
        <div *ngIf="pet.status !== petStatus.Deceased" class="col-12">
          <div class="row">
            <div class="col-12 col-md-3 d-flex justify-content-md-start justify-content-center" [ngClass]="{'page-title': useRebrandedLayout }" >
              <div class="pet-name-title">{{ pet.name }}'s {{ petNameTitleSuffix }}</div>
            </div>
            <div
              class="col-12 col-md-9 d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-center align-items-md-start"
            >
              <div *appFeatureFlag="'isPetBioUpdateAvailable'" class="button-container mb-2 mb-md-0">
                <button
                  class="btn btn-secondary text-white w-100 edit-pet-button"
                  type="button"
                  (click)="onClickEditPetBio()"
                  [disabled]="pet.isTokPaymentRequired"
                >
                  <img class="button-with-pawn" src="/assets/images/identibase/whitepawlarge.png" *appFeatureFlag="'isPawnVisibleInButton'"/>
                  Edit pet {{ petNameTitleSuffix }}
                </button>
              </div>
              <div class="button-container mb-2 mb-md-0 ms-md-2" *ngIf="!!pet.hasQrCodeTag">
                <button
                  class="btn btn-secondary text-white w-100"
                  type="button"
                  (click)="editQRCodePreferences()"
                  [disabled]="pet.isTokPaymentRequired"
                >
                  Edit QR code preferences
                </button>
              </div>
              <div class="button-container mb-2 mb-md-0 ms-md-2" *ngIf="!!pet.hasQrCodeTag">
                <button class="btn btn-secondary text-white w-100" type="button" disabled>
                  Edit Smart Tag
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-3" />

      <div *appFeatureFlag="'isPetBioAvailable'" class="row">
        <div class="col-md-6">
          <ul class="list-group bio-left">
            <li class="list-group-item">
              <h5 class="text-primary">Pet name</h5>
              {{ pet.name }}
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">Chip number</h5>
              {{ pet.chipNumber }}
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">{{ petTypeText }}</h5>
              {{ pet.species }}
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">{{ petBreedText }}</h5>
              {{ pet.breed }}
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">{{ petDateOfBirthText }}</h5>
              {{ pet.dob | date: 'MM/y' }}
            </li>
            <li *appFeatureFlag="'isPetPageInstagramHandleEnabled'" class="list-group-item">
              <h5 class="text-primary">Pet’s Instagram handle</h5>
              {{
                pet.instagram
                  ? pet.instagram.charAt(0) === '@'
                    ? pet.instagram
                    : '@' + pet.instagram
                  : '-'
              }}
            </li>
            <li class="list-group-item" *appFeatureFlag="'isShowChipNumberEnabled'">
              <h5 class="text-primary">{{ chipNumberText }}</h5>
              {{ pet.chipNumber }}
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <ul class="list-group bio-right">
            <li class="list-group-item">
              <h5 class="text-primary">Implant date</h5>
              {{ pet.implantDate | date: 'dd/MM/y' }}
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">Sex</h5>
              <span *ngIf="pet.gender === petGender.Unknown">Unknown</span>
              <span *ngIf="pet.gender === petGender.Male">Male</span>
              <span *ngIf="pet.gender === petGender.Female">Female</span>
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">Neutered/spayed</h5>
              {{ pet.neutered ? 'Yes' : pet.neutered === false ? 'No' : 'Not provided' }}
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">{{ petColoursMarkingsText }}</h5>
              {{ pet.coloursMarkings ? pet.coloursMarkings : 'Not provided' }}
            </li>
            <li class="list-group-item">
              <h5 class="text-primary">{{ petConditionsText }}</h5>
              {{ pet.existingConditions ? pet.existingConditions : 'Not provided' }}
            </li>
          </ul>
        </div>
      </div>

      <hr class="my-4" />

      <div *appFeatureFlag="'isPetActionsAvailable'" class="row actions-features">
        <div class="col-md-12 col-sm-1">
          <h5 [ngClass]="{'page-title': useRebrandedLayout }">
            {{
              pet.status !== 2 &&
              (user.productType === productType.Locator || 
                user.productType === productType.Premium ||
                user.productType === productType.LegacyPremium)
                ? 'Actions'
                : 'Basic features'
            }}
          </h5>
          <div class="mt-3">
            <div class="bottom-button-container">
              <ng-container *appFeatureFlag="'isPetMissingActionAvailable'">
                <div
                  *ngIf="
                    !userService.isUserBasicOrBasicPlus(user.productType) &&
                    pet.status !== petStatus.Deceased &&
                    pet.residence === petResidenceStatus.AtHome &&
                    !rejectedMissingReport
                  "
                  class="me-2"
                >
                  <button
                    class="badge btn btn-primary bottom-button bottom-button-highlighted"
                    (click)="onClickMissing()"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    Tell us {{ pet.name }} is missing
                  </button>
                </div>
              </ng-container>
              <ng-container *appFeatureFlag="'isPetMissingActionAvailable'">
                <div
                  *ngIf="
                    userService.isUserBasicOrBasicPlus(user.productType) &&
                    pet.status !== petStatus.Deceased &&
                    pet.residence === petResidenceStatus.AtHome
                  "
                  class="me-2"
                >
                  <button
                    class="badge btn btn-primary me-2 bottom-button bottom-button-highlighted"
                    (click)="onClickMarkLostStolen(); trackEvent('petpage::lostpet::clicked')"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    Tell us {{ pet.name }} is missing
                  </button>
                </div>
              </ng-container>
              <ng-container *appFeatureFlag="'isPetViewQRCodeDataActionAvailable'">
                <div *ngIf="!!pet.hasQrCodeTag && pet.status !== 2" class="me-2">
                  <button
                    class="badge btn btn-lg bottom-button"
                    [ngClass]="useRebrandedLayout ? 'btn-secondary text-black' : 'btn-primary'"
                    (click)="viewQRCodeData()"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    View {{ pet.name }}'s QR code data
                  </button>
                </div>
              </ng-container>
              <ng-container *appFeatureFlag="'isPetPDFActionAvailable'">
                <div class="me-2">
                  <button
                    class="badge btn bottom-button"
                    [ngClass]="useRebrandedLayout ? 'btn-secondary text-black' : 'btn-primary'"
                    (click)="downloadCertificate()"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    Download/print {{ pet.name }}'s certificate
                  </button>
                </div>
              </ng-container>
              <ng-container *appFeatureFlag="'isPetPassedAwayActionAvailable'">
                <div *ngIf="pet.status !== petStatus.Deceased" class="me-2">
                  <button
                    class="badge btn bottom-button"
                    [ngClass]="useRebrandedLayout ? 'btn-secondary text-black' : 'btn-primary'"
                    (click)="onClickPassedAway()"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    Tell us {{ pet.name }} has passed away
                  </button>
                </div>
              </ng-container>
              <ng-container *appFeatureFlag="'isPetArchiveActionAvailable'">
                <div *ngIf="pet.archived !== true && pet.status === petStatus.Deceased" class="me-2">
                  <button
                    class="badge btn bottom-button"
                    [ngClass]="useRebrandedLayout ? 'btn-secondary text-black' : 'btn-primary'"
                    (click)="onClickArchive()"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    Archive {{ pet.name }}
                  </button>
                </div>
              </ng-container>
              <ng-container *appFeatureFlag="'isPetUnarchiveActionAvailable'">
                <div *ngIf="pet.archived === true" class="me-2">
                  <button
                    class="badge btn bottom-button"
                    [ngClass]="useRebrandedLayout ? 'btn-secondary text-black' : 'btn-primary'"
                    (click)="onClickUnarchive()"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    Unarchive {{ pet.name }}
                  </button>
                </div>
              </ng-container>
              <ng-container *appFeatureFlag="'isPetRehomeActionAvailable'">
                <div
                  *ngIf="
                    pet.status !== petStatus.Deceased && pet.residence === petResidenceStatus.AtHome
                  "
                  class="me-2"
                >
                  <button
                    class="badge btn bottom-button"
                    [ngClass]="useRebrandedLayout ? 'btn-secondary text-black' : 'btn-primary'"
                    (click)="onClickRehome()"
                    [disabled]="pet.isTokPaymentRequired"
                    type="button"
                  >
                    Tell us you wish to rehome {{ pet.name }}
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="
          (userService.isUserBasicOrBasicPlus(user.productType) ||
            user.productType === productType.LegacyPlus) &&
          pet.status !== petStatus.Deceased
        "
        class="row mt-5"
      >
        <div class="col-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
          <button
            class="btn text-white float-sm-end w-100"
            [ngClass]="useRebrandedLayout ? 'btn-primary' : 'btn-success'"
            routerLink="/account/account-type"
            (click)="trackEvent('petpage::upgradepremium::clicked')"
            [disabled]="pet.isTokPaymentRequired"
          >
            Membership options
            <fa-icon class="d-inline-block ms-1" [icon]="['fas', 'chevron-right']"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
